import { FC } from 'react'
import { ClockInOutDetailsBase } from 'screens/Rostering/components/ClockInOutDetailBase'
import { ClockInOutAction } from 'screens/Rostering/hooks/useClockInOut'
import { ClockInLocation } from 'screens/Rostering/types'

type ClockInDetailsProps = {
  time?: string
  note?: string
  location?: ClockInLocation
  openClockInOutModal: () => void
  warnings?: string[]
  action: ClockInOutAction
  isDraft?: boolean
  isDeletedSU?: boolean
  timezone?: string
  publishedRota?: boolean
}

export const ClockInDetails: FC<ClockInDetailsProps> = (props) => (
  <ClockInOutDetailsBase {...props} type="in" />
)
